import anime from 'animejs';

/**
 *  Logic behind main menu (popup)
 */
class MainMenu {

    constructor(containerSelector) {
        this.module = {};
        this.popupContainer = $(containerSelector);
        this.containerSelector = containerSelector;

        this.currentMenuId = 0;

        this.attachEvents();
        this.secondary();
    }

    secondary() {
        let secondaryMenu = document.querySelector('.secondary-menu');

        if (! secondaryMenu) {
          return;
        }

        let secondaryList = secondaryMenu.querySelector('ul');
        let secondaryMenuPrev = secondaryMenu.querySelector('.secondary-menu__prev');
        let secondaryMenuNext = secondaryMenu.querySelector('.secondary-menu__next');

        let scrollOffset = 15;
        let ticking = false;

        if (secondaryMenu.clientWidth !== secondaryMenu.scrollWidth) {
          secondaryList.style.justifyContent = 'flex-start';
        }

        // show hide right arrow on load
        if ((secondaryMenu.scrollWidth - scrollOffset) <= (secondaryMenu.scrollLeft + secondaryMenu.clientWidth)) {
          secondaryMenuNext.style.opacity = 0;
        } else {
          secondaryMenuNext.style.opacity = 1;
        }

        function arrows_toggle() {
          if (secondaryMenu.scrollLeft > scrollOffset) {
            secondaryMenuPrev.style.opacity = 1;
          } else {
            secondaryMenuPrev.style.opacity = 0;
          }

          if ((secondaryMenu.scrollWidth - scrollOffset) <= (secondaryMenu.scrollLeft + secondaryMenu.clientWidth)) {
            secondaryMenuNext.style.opacity = 0;
          } else {
            secondaryMenuNext.style.opacity = 1;
          }
        }

        secondaryMenu.addEventListener('scroll', function(e) {
          if (! ticking) {
            requestAnimationFrame(function() {
              arrows_toggle();
              ticking = false;
            });

            ticking = true;
          }
        });
    }

    setEqualHeight(item) {
      // Set equal height for the column item name
      let _menuItems = $(item).find('.menu__item__name');
      let _highest = 0;

      _menuItems.each(function () {
        if ($(this).height() > _highest) {
          _highest = $(this).height();
        }
      });

      _menuItems.height(_highest);
    }

    attachEvents() {
        // bind the open action
        $('[data-popup-trigger="' + this.containerSelector + '"]').on("click", e => {

            // Get the id of the menu item we clicked
            this.currentMenuId = $(e.target).data('menu-id');

            // Fetch the menu of the clicked ID
            const currentMenu = document.querySelector('.menu[data-menu-id="' + this.currentMenuId + '"]');
            const mainMenu = document.getElementById('main-menu-popup');

            currentMenu.style.display = 'block';
            mainMenu.style.display = 'block';

            this.setEqualHeight(currentMenu);

            // Do we slide from bottom or top
            let from = -1000;
            if ($(window).width() < 992) {
              from = 1000;
            }

            anime({
              targets: currentMenu,
              translateY: [from, 0],
              duration: 1000,
              easing: 'easeInOutSine',
              begin: function () {
                mainMenu.style.display = "block";

                // Set equal height for the column item name
                let _menuItems = $(currentMenu).find('.menu__item__name');
                let _highest = 0;

                _menuItems.each(function () {
                  if ($(this).height() > _highest) {
                    _highest = $(this).height();
                  }
                });

                _menuItems.height(_highest);

              }
            });

            anime({
              targets: mainMenu,
              opacity: [0, 1],
              duration: 750,
              easing: 'easeInOutSine',
            });

        });


        // activate item on click
        this.popupContainer.find("a[data-id]").on("click", e => {
            let menuId = $(e.currentTarget).data('id');

            // if the target menuId == 0 slide to right

            let screenWidth = window.innerWidth;
            let prevTargetX = -1 * screenWidth;
            let curStartX = screenWidth;

            if (menuId == 0) {
              prevTargetX = screenWidth;
              curStartX = -1 * screenWidth;
            }

            anime({
              targets: $('.menu[data-menu-id="' + this.currentMenuId + '"]').get(0),
              translateX: prevTargetX,
              easing: 'easeInOutSine',
              duration: 400,
              complete: function() {
                $('.menu[data-menu-id="' + this.currentMenuId + '"]').hide();
              }
            });

            anime({
              targets: $('.menu[data-menu-id="' + menuId + '"]').get(0),
              translateX: [curStartX, 0],
              easing: 'easeInOutSine',
              duration: 400,
              begin: function() {
                $('.menu[data-menu-id="' + menuId + '"]').show();
              },
              complete: function() {
              }
            });

            this.currentMenuId = menuId;
        });

        this.popupContainer.find(".close").on("click", e => {
            let to = -1000;
            if ($(window).width() < 992) {
              to = 1000;

              anime({
                targets: document.getElementById('main-menu-popup'),
                translateY: to,
                duration: 500,
                easing: 'easeInOutSine',
                complete: function() {
                  closeMenu();
                }
              });

              anime({
                targets: document.getElementById('main-menu-popup'),
                opacity: [1, 0],
                duration: 500,
                easing: 'easeInOutSine',
              });

            } else {
              closeMenu();
            }

            // Remove the active state from the toggle button (fixes double hamburger click)
            $('[data-popup-trigger="' + this.containerSelector + '"]').removeClass('active');

        });

        let secondaryMenu = $('.secondary-menu');
        let scrolling = false,
		        previousTop = 0,
		        scrollDelta = 0;

        // Show/hide secondary on mobile
        $(window).on('scroll', function(){
          if (! scrolling ) {
            scrolling = true;
            (! window.requestAnimationFrame)
              ? setTimeout(autoHideHeader, 100)
              : requestAnimationFrame(autoHideHeader);
            }
        });

        function closeMenu() {

          let mainMenu = document.getElementById('main-menu-popup');

          if (mainMenu.classList.contains('reveal')) {
            mainMenu.classList.remove('reveal')
          }

          mainMenu.style.display = 'none';
          // Another JS is attaching this on popup open...
          $('body').removeClass('popup-active');

          // Hide all menus
          $('.menu').hide();
          // Reset transforms
          // $('.menu').css('transform', 'none');

          $('#main-menu-popup').removeClass('active');

          document.getElementById('main-menu-popup').style.transform = 'none';
        }

        function autoHideHeader() {
          let currentTop = $(window).scrollTop();

          if ($('#mobile').is(':visible') || $('#tablet').is(':visible')) {
            checkStickyNavigation(currentTop);
          }

          previousTop = currentTop;
          scrolling = false;
        }

        function checkStickyNavigation(currentTop) {
          if (previousTop >= currentTop ) {
              // if scrolling up or on top
              if ((previousTop - currentTop > scrollDelta ) || (currentTop < 128))  {
                // secondary nav is fixed
                secondaryMenu.removeClass('is-hidden');
              }

            } else {
              // if scrolling down, hide when below 128px
              if (currentTop > 128) {
                secondaryMenu.addClass('is-hidden');
              }
            }
        }
    }
}

export { MainMenu };
